import {useMutation} from "@tanstack/react-query";

import {editSupplierNoteMutationOptions} from "./edit-supplier-note.mutation-options";

export function useEditSupplierNote(supplierId: string, noteId: number) {
  return useMutation(editSupplierNoteMutationOptions(supplierId, noteId));
}
